exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".no-search-results{display:flex;justify-content:center;padding:15px 0;font-size:20px;font-weight:700}", ""]);

